module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department05-2ac1bb13f0b0c80acb1bd816be7c8aad.jpg";